<script>
import {computed, ref, watch} from "vue";
import useSharedMethod from "@/use/SharedMethod";

export default {
    props: {
        value: [String, Number],
        readonly: Boolean,
        label: String,
        hideDetails: [String, Boolean],
        priceFormat: Boolean,
        paySlipFormat: Boolean,
        hideChip: Boolean,
    },
    emits: ["save", "open"],
    setup(props, {emit}) {
        const {priceFormat} = useSharedMethod();

        const valeur = ref(null);

        const formattedValue = computed(() => {
            if(props.priceFormat)
                return priceFormat(valeur.value)
            return valeur.value;
        });

        function save() {
            if (valeur.value === null || valeur.value === undefined) {
                valeur.value = 0;
            }

            emit('input', valeur.value);
            emit('save');
        }
        
        function open() {
             if (valeur.value === 0)
                valeur.value = null;
            emit('open');
        }
        
        watch(() => props.value, () => {
            if (props.value !== null && props.value !== undefined)
                valeur.value = props.value;
        }, {immediate: true});

        return {
            valeur,
            formattedValue,
            save,
            open
        }
    }
}
</script>

<template>
    <div>
        <span v-if="readonly">{{ formattedValue }}</span>
        <v-edit-dialog
            v-else
            :return-value.sync="valeur"
            @open="open"
            @save="save"
        >
            <span v-if="hideChip">{{ formattedValue }}</span>
            <w-chip
                v-else
                outlined
                icon="mdi-pencil"
                :text="formattedValue"
            />
            <template v-slot:input>
                <div v-if="label">{{ label }}</div>
                <v-text-field
                    v-model="valeur"
                    auto-focus
                    dense
                    :readonly="readonly"
                    :hide-details="hideDetails"
                />
            </template>
        </v-edit-dialog>

        <input type="hidden"/>
    </div>
</template>

<style scoped>

</style>